import { BaseParameterDto } from './base-parameter-dto';

export class GetStatesParameterDto extends BaseParameterDto {
    countryCode: string;

    constructor(countryCode?: string) {
        super();
        this.countryCode = countryCode;
    }

    getQueryString(): string {
        return `?countryCode=${this.countryCode}&clearCache=${this.clearCache}`;
    }
}
